import React, { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import './App.css';
import Blog from './pages/Blog/index.jsx';
import Home from './pages/Home';

const App = () => {

  const getMode = () => {
    return JSON.parse(localStorage.getItem("mode")) || false
  }
  const [dark, setMode] = useState(getMode());
  useEffect(() => {
    localStorage.setItem("mode", JSON.stringify(dark))
  },[dark])
  // const [dark, setMode] = useState(false);

  return (
    <div className={dark ? "dark-mode" : "light-mode"}>
      <div className="container">

        <div className="toggle">
          <label className="switch">
            <input type="checkbox" checked={dark} onChange={() =>setMode(!dark)} />
            <span className="slider round"></span>
          </label>
        </div>
        <Switch>
          <Route path='/' exact component={Home}/>
            <Route exact path="/blog/:id">
              <Blog data={dark}/>
            </Route>
            <Redirect to='/' />
        </Switch>
      </div>
    </div>
  );
};

export default App;
